/**
 * ActionButtons Component
 *
 * Submit, Reset, and Save buttons for movement analysis.
 * Uses getUser() from SLAM helpers instead of Firebase auth.
 * Mode: Deep Analysis (Mode 3)
 */
import React from 'react';
import { Save, Loader2 } from 'lucide-react';
import { getUser } from '../../utils/helpers';

export const ActionButtons = ({
  handleSubmitForAnalysis,
  handleReset,
  saveAnalysis,
  isLoading,
  isSaving,
  uploadedVideo,
  question,
  analysis,
}) => {
  const user = getUser();

  return (
    <div className="flex flex-col space-y-3">
      <div className="flex space-x-3">
        <button
          onClick={handleSubmitForAnalysis}
          disabled={!uploadedVideo || !question.trim() || isLoading}
          className="w-full rounded-xl bg-orange-500 hover:bg-orange-600 text-white px-4 py-2.5 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isLoading ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Analyzing...
            </>
          ) : (
            'Analyze My Technique'
          )}
        </button>
        <button
          onClick={handleReset}
          disabled={isLoading}
          className="rounded-xl border border-white/15 bg-white/[0.04] px-4 py-2.5 text-sm text-zinc-200 hover:bg-white/[0.08] disabled:opacity-50"
        >
          Reset
        </button>
      </div>

      {analysis && user?.userId && (
        <button
          onClick={saveAnalysis}
          disabled={isSaving || !analysis}
          className="w-full rounded-xl border border-white/15 bg-white/[0.04] px-4 py-2.5 text-sm text-zinc-200 hover:bg-white/[0.08] disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {isSaving ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" />
              Save Analysis to My Account
            </>
          )}
        </button>
      )}
    </div>
  );
};
